import React from 'react';

function Footer() {
  return (
    <footer className="bg-light text-center text-muted py-3 mt-auto">
      <small>&copy; {new Date().getFullYear()} Visitor Management System | All rights reserved.</small>
    </footer>
  );
}

export default Footer;
